import React, { useState } from "react";
import pic from "../images/call.png";
import pic1 from "../images/mail.png";

const Contact = () => {
  const [user, setUser] = useState({
    emailId: "",
    name: "",
    message: "",
  });

  let name, value;

  const getUserData = (event) => {
    name = event.target.name;
    value = event.target.value;

    setUser({ ...user, [name]: value });
  };

  const postData = async (e) => {
    e.preventDefault();

    const {emailId, name, message,} = user;
    
    if(emailId && name && message) {
      const res = await fetch(
        "https://portfoliodb-c5616-default-rtdb.firebaseio.com/portfoliodb.json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            emailId,
            name,
            message,
          })
        }
      );
  
      if(res) {
        setUser({
          emailId: "",
          name: "",
          message: "",
        });
        alert("Message sent :)");
      }
      else {
        alert("PLZ fill the data");
      }
    }
    else{
      alert("Plz fill all details !!! ")
    }
  };
  return (
    <>
    <div id='Contact' className='section-padding'>
      <h1 className="text-black text-4xl font-bold text-center mt-5">
        Connect with me{" "}
      </h1>
      
        <div className="mt-6 grid grid-cols-1">
            <div className="mb-4 content-center border border-solid rounded-xl shadow-lg border-white-200 bg-white ml-8 mr-8 lg:ml-60 lg:mr-60">
              <div className="row divide-x-2">
                <div className="col-5 lg:mt-5 mb-3">
                <img src={pic} className="mx-auto" alt="" width="60px" />
                    <h2 className="text-center">Phone</h2>
                    <h3 className="text-slate-400	text-center">
                      +91 6201293283
                    </h3>
                </div>
                <div className="col-7 pr-1 lg:p-5 mb-2">
                <img src={pic1} className="mx-auto" alt="" width="60px" />
                    <h2 className="text-center	">Mail</h2>
                    <h3 className="text-slate-400 text-center">
                      fatma.sia2020@gmail.com
                    </h3>
                    <h3 className="text-slate-400	text-center">
                      techAasia27@gmail.com
                    </h3>
                </div>
              </div>
            </div>
          </div>
      {/* <div className="ml-4">
                <div className="p-2 divide-x-2">
                  <div className="phone">
                    <img src={pic} className="mx-auto" alt="" width="60px" />
                    <h2 className="text-center">Phone</h2>
                    <h3 className="text-slate-400	text-center">
                      +91 6201293283
                    </h3>
                  </div>
                  <br />
                  <div className="mail">
                    <img src={pic1} className="mx-auto" alt="" width="60px" />
                    <h2 className="text-center	">Mail</h2>
                    <h3 className="text-slate-400 text-center">
                      fatma.sia2020@gmail.com
                    </h3>
                    <h3 className="text-slate-400	text-center">
                      techAasia27@gmail.com
                    </h3>
                  </div>
                </div>
              </div> */}
    
      </div>
    </>
  );
};

export default Contact;
